import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TipoDanno } from '../models/tipo-danno';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class TipoDannoService extends ResourcefulService<TipoDanno>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, TipoDanno);
    }
}
